import { apiUrl } from '../../../settings'

export const createEventUrl = () => {
  return apiUrl + '/event/add'
}

export const listAllEventsUrl = () => {
  return apiUrl + '/event/list'
}
export const updateEventUrl = () => {
  return apiUrl + '/event/update'
}
export const deleteEventUrl = () => {
  return apiUrl + '/event/delete'
}
